<!--
  TODO: consider renaming this to SaveLiveStreamButton and merging similarities
    with SaveSubscriptionButton (the other one in PlayerSubscriptionEditorView)
    if any similarities exist.
-->
<template>
  <Dialog ref="savingDialog">
    <template #expander>
      <ButtonCustomized
        label="Save"
        data-testid="live-stream-save"
        @click="saveLiveStream"
        :disabled="!hasUnsavedChanges"
      />
    </template>
    <template #dialog.title>{{ dialogTitle }}</template>
    <template #dialog.content="{closeModal, closeModalAfter}">
      <div class="saving-progress-dialog-content">
        <!-- TODO: think about adding height option for StatusBar — N2LBs3CL -->
        <StatusBar
          :errorMessage="errorMessage"
          :isLoading="isLoading"
          :loadingMessage="loadingMessage"
          :isSuccess="isSuccess"
          :successMessage="successMessage"
        />
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import useNotifications from '@/components/Notifications/composables/notifications';
import { useLiveStream } from '../composables/liveStream';
import { useSaveLiveStreamFormHelpers } from '../composables/saveLiveStreamFormHelpers';
import { computed, ref } from 'vue';

defineExpose({
  saveLiveStream
})

const notification = useNotifications();
const { submitForm, isSuccess, errorMessage, isLoading } = useSaveLiveStreamFormHelpers();
const { hasUnsavedChanges, unsetHasUnsavedChanges } = useLiveStream();

const savingDialog = ref();

type UpdateAction = "start" | "stop" | "saving";
const activeAction = ref<UpdateAction>("saving");
const dialogTitle = computed(() => {
  return activeAction.value === "start" ? "Starting" : activeAction.value === "stop" ? "Stopping" : "Saving";
});
const loadingMessage = computed(() => {
  return activeAction.value === "start" ? "Starting..." : activeAction.value === "stop" ? "Stopping..." : "Saving...";
});
const successMessage = computed(() => {
  return activeAction.value === "start" ? "Started!" : activeAction.value === "stop" ? "Stopped!" : "Saved!";
});

async function saveLiveStream(updateAction: UpdateAction = "saving") {
  activeAction.value = updateAction;
  savingDialog.value.openModal();
  await submitForm();
  if(isSuccess.value === true) {
    const actionDoneText = updateAction === "start" ? "started" : updateAction === "stop" ? "stopped" : "saved";
    notification.success(`Live Stream ${actionDoneText} successfuly!`);
    unsetHasUnsavedChanges({resetDataInitializationState: false});
    savingDialog.value.closeModalAfter(1000);
  } else {    // on failure
    const actionFailedText = updateAction === "start" ? "starting" : updateAction === "stop" ? "stopping" : "saving";
    notification.failure(`Live Stream ${actionFailedText} failed!`);
  }
}


</script>

<style lang="scss" scoped>
.saving-progress-dialog-content {
  min-height: 60px;
  min-width: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}
</style>